import { EventEmitter } from '@angular/core';
import { Component, Input, Output } from '@angular/core';

/**
 * Commponent for spinner
 */
@Component({
  selector: 'app-page-spinner',
  template: ` <div class="esf-spinner flex-container-loading" *ngIf="show">
                <div class="row">
                  <span class="esf-spinner__bounce esf-spinner__bounce--1"></span>
                  <span class="esf-spinner__bounce esf-spinner__bounce--2"></span>
                  <span class="esf-spinner__bounce esf-spinner__bounce--3"></span>
                </div>
              </div>`
})
export class PageSpinnerComponent {
  public isShowing: boolean = false;

  @Output() public showChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input()
  get show(): boolean {
    return this.isShowing;
  }
  set show(val: boolean) {
    this.isShowing = val;
    this.showChange.emit(this.isShowing);
  }

  constructor() { }

}
